import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import { FormControlLabel } from 'material-ui/Form';
import TextField from 'material-ui/TextField';
import Radio, { RadioGroup } from 'material-ui/Radio';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import Snackbar from 'material-ui/Snackbar';
import CopyToClipboard from 'react-copy-to-clipboard';
import loremIpsum from 'lorem-ipsum';

class TextGenerator extends Component {
	state = {
		showCopyMessage: false,
		text: '',
		count: 50,
		units: 'words'
	}

	componentWillMount() {
		this.generateText();
	}

	generateText = () => {
		const { count, units } = this.state;
		let text = loremIpsum({
			format: 'html',
			count,
			units
		});

		this.setState({ text });
	}

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		}, this.generateText);
	}

	toggleCopiedMessage = () => {
		this.setState({
			showCopyMessage: !this.state.showCopyMessage
		});
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
				<Grid container className={classes.container}>
					<Grid item xs={12} sm={6} md={4} lg={3}>
						<TextField name="count" label="Count" type="number" value={this.state.count} fullWidth={true} onChange={this.handleChange} />
					</Grid>
					<Grid item xs={12} sm={6} md={8} lg={9}>
						<RadioGroup row name="units" value={this.state.units} onChange={this.handleChange}>
							<FormControlLabel value="words" control={<Radio />} label="Words" />
							<FormControlLabel value="sentences" control={<Radio />} label="Sentences" />
							<FormControlLabel value="paragraphs" control={<Radio />} label="Paragraphs" />
						</RadioGroup>
					</Grid>
				</Grid>
				<div className={classes.container}>
					<CopyToClipboard text={this.state.text} onCopy={this.toggleCopiedMessage}>
						<Button color="primary">Copy text</Button>
					</CopyToClipboard>
					<Button onClick={this.generateText}>Generate text</Button>
				</div>
				<Paper className={classes.paper}><Typography>{this.state.text}</Typography></Paper>
				<Snackbar message="Text has been copied to the clipboard" open={this.state.showCopyMessage} autoHideDuration={5000} onClose={this.toggleCopiedMessage} />
			</div>
		);
	}
};

TextGenerator.propTypes = {
	classes: PropTypes.object.isRequired
};

const styles = theme => ({
	container: {
		marginTop: theme.spacing.unit * 3
	},
	paper: {
		padding: theme.spacing.unit * 3,
		marginTop: theme.spacing.unit * 3
	}
});

export default withStyles(styles)(TextGenerator);



// WEBPACK FOOTER //
// ./src/components/TextGenerator/index.js